<template>

<com-item name="games.compare" :size="size" :loading="loading" :is-empty="!active" title="Peers">

	<template v-slot:about>

		<p>How {{ your }} universe size compares to other users.</p>

	</template>

	<template v-slot:stats>

		<template v-if="active">

			<app-visualisation-percentile :data="graph" class="compare-graph" />

			<div class="compare-metrics">

				<com-overview :inline="true" :inset="true" type="template" :value="data.metrics.percentile | nth(true)" label="Percentile" />

				<com-overview :inline="true" :inset="true" :theme="(data.metrics.median >= 0) ? 'green': 'red'" type="number" :value="data.metrics.median | abs" label="vs Median" :caret="(data.metrics.median >= 0) ? 'up': 'down'" />

			</div>

		</template>

	</template>

</com-item>

</template>

<script>

import comOverview from './../common/Overview'
import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem,
		'com-overview': comOverview
	},

	data: function() {

		return {
			graph: {
				plain: true,
				datasets: [
					{ type: 'bar', data: [], highlight: false, backgroundColor: '#4881bb', tooltip: '{{value}} user{{value.plural}} <small>{{x.label}}</small>' }
				],
				axis: {
					x: {
						labels: []
					},
					y: {
						min: 10,
						points: 10
					}
				}
			}
		}

	},

	computed: {

		loading: function() {

			return this.fetching === 'all'

		},

		data: function() {

			return this.$store.getters['page/insights/games/compare']

		},

		active: function() {

			return this.data && this.data.histogram && this.data.histogram.data && this.data.histogram.data.length && !this.loading

		}

	},

	watch: {

		data: function() {

			this.visualise()

		}

	},

	created: function() {

		this.visualise()

	},

	methods: {

		visualise: function() {

			if (!this.data || !this.data.histogram) return

			this.graph.datasets[0].data = []
			this.graph.axis.x.labels = []

			this.graph.datasets[0].highlight = this.data.histogram.position

			for (var i = 0; i < this.data.histogram.data.length; i++) {

				this.graph.axis.x.labels.push({
					label: this.data.histogram.labels[i],
					sublabel: ''
				})

				this.graph.datasets[0].data.push(this.data.histogram.data[i])

			}

		}

	}

}

</script>

<style scoped>

.compare-graph {
	width: 100%;
	padding: 0px 2px 0px 2px;
	flex-grow: 1;
}

.compare-metrics {
	height: 80px;
	flex-shrink: 0;
	border-top: 1px solid #ddd;
	display: grid;
	grid-template-columns: 1fr 1fr;
	align-items: center;
}

.compare-metrics >>> .overview-item {
	grid-column: span 1;
}

</style>
